import React from 'react'
import { Link, NavLink } from "react-router-dom";

import card1 from '../../assets/Images/slider1.png';
import card2 from '../../assets/Images/slider2.png';
import card3 from '../../assets/Images/slider3.png';
import { FaArrowRight } from "react-icons/fa";

function ServicesCard() {
  return (
    <section className='services-card'>
      <div className="container">
        <div className="d-flex flex-lg-row flex-md-row flex-sm-column flex-column align-items-center justify-content-center gap-4 mb-4">
            <div className="service-card">
                <figure className='d-flex align-items-center justify-content-center'>
                    <img src={card1} alt="card1.img" style={{color: '#d3c9c1'}} />
                </figure>
                <h3>UI/UX Design</h3>
                <p>Transforming your digital experience with intuitive design and seamless navigation. We craft user interfaces that delight, ensuring every interaction is engaging and effortless.</p>
                <Link to = "/service" className='d-flex align-items-center'>
                    Read more <FaArrowRight style={{color: '#ffffff'}}/>
                </Link>
            </div> {/* data-aos="fade-down" data-aos-easing="ease" data-aos-duration="1300" */}
            <div className="service-card">
                <figure className='d-flex align-items-center justify-content-center'>
                    <img src={card2} alt="card1.img" style={{color: '#d3c9c1'}} />
                </figure>
                <h3>Web Development</h3>
                <p>Empowering businesses with cutting-edge development solutions, from sleek web applications to robust software systems, tailored to boost efficiency and drive digital transformation.</p>
                <Link to = "/service" className='d-flex align-items-center'>
                    Read more <FaArrowRight style={{color: '#ffffff'}}/>
                </Link>
            </div> {/*  data-aos="fade-up" data-aos-easing="ease" data-aos-duration="1300" */}
            <div className="service-card">
                <figure className='d-flex align-items-center justify-content-center'>
                    <img src={card3} alt="card1.img" style={{color: '#d3c9c1'}} />
                </figure>
                <h3>Video Editing</h3>
                <p>Transform your raw footage into captivating stories with our expert video editing. From seamless transitions to stunning effects, we bring your vision to life.</p>
                <Link to = "/service" className='d-flex align-items-center'>
                    Read more <FaArrowRight style={{color: '#ffffff'}}/>
                </Link>
            </div> {/* data-aos="fade-down" data-aos-easing="ease" data-aos-duration="1300" */}
        </div>
      </div>
    </section>
  )
}

export default ServicesCard
